import { Pipe, PipeTransform, inject } from '@angular/core';
import { SpecMetaService } from '../data/data-files/spec-meta-service';

// A pure pipe would cache the pre-hydration ''.
@Pipe({ name: 'classIcon', pure: false })
export class ClassIconPipe implements PipeTransform {
  private readonly specMeta = inject(SpecMetaService);

  transform(className: string | null | undefined): string {
    return this.specMeta.classIconUrl(className ?? '');
  }
}
